import React from "react";
import { negate } from "lodash";
import { useStore as useAuthStore } from "auth/store";
import { TaskList } from "tasks/components/TaskList/TaskList";
import {
  areDueAtFiltersActive,
  getCommonDates,
  isPartlyWithinDateRange,
} from "tasks/helpers";
import { useStore as useTasksStore } from "tasks/store";
import { FilterTriaged } from "typings/globalGQLTypes";

export const shouldShowTasks = (user: User) => {
  return user.isTOMMember || user.isGETMember || user.isHKManager;
};

export const TaskLists = () => {
  const {
    state: { user },
  } = useAuthStore();
  const {
    state: { groupBy },
  } = useTasksStore();

  if (!user || !shouldShowTasks(user)) {
    return null;
  }

  const { startOfToday, endOfToday, endOfTomorrow } = getCommonDates();

  return (
    <>
      <TaskList
        filters={{ triaged: FilterTriaged.new }}
        id="new"
        isActive={negate(areDueAtFiltersActive)}
        limit={50}
        // "New tasks" are defined as not having a due date, so we hide the list
        // whenever any global due at filters are set
        title="New tasks"
      />
      {groupBy === "everything" && (
        <TaskList
          showEmpty
          filters={{ triaged: FilterTriaged.triaged }}
          id="everything"
          limit={50}
          title="Triaged tasks"
        />
      )}
      {groupBy === "due-date" && (
        <>
          <TaskList
            filters={{ dueAtStart: null, dueAtEnd: startOfToday }}
            id="pastdue"
            isActive={isPartlyWithinDateRange}
            limit={50}
            // Global filters might be more specific than local filters. We want
            // to render the task list whenever there is a chance that any items
            // might show up in it, so we look for any overlap between the local
            // filters and global filters. `null` values are treated as dates
            // infinitely in the past or the future.
            title="Past due"
          />
          <TaskList
            showEmpty
            filters={{ dueAtStart: startOfToday, dueAtEnd: endOfToday }}
            id="today"
            isActive={isPartlyWithinDateRange}
            limit={50}
            title="Today's tasks"
          />
          <TaskList
            filters={{ dueAtStart: endOfToday, dueAtEnd: endOfTomorrow }}
            id="tomorrow"
            isActive={isPartlyWithinDateRange}
            limit={50}
            title="Tomorrow's tasks"
          />
          <TaskList
            filters={{ dueAtStart: endOfTomorrow, dueAtEnd: null }}
            id="upcoming"
            isActive={isPartlyWithinDateRange}
            limit={50}
            title="Upcoming tasks"
          />
        </>
      )}
    </>
  );
};
